import React from "react";
import { Icon } from "best-common-react";
import { inject } from "mobx-react";

function DigitalSeatIdFormatter(props) {
  const value = props.value;
  const { authStore, digitalTicketsIdsStore } = props.rootStore;

  if (!authStore.isGlobal || !value.forwardId) {
    return <div />;
  } else {
    return (
      <div>
        <Icon
          iconName="fa-exclamation-circle"
          onClick={() => {
            digitalTicketsIdsStore.setShowDigitalTicketsIdsModal(true);
            digitalTicketsIdsStore.setRequest(value);
          }}
        />
      </div>
    );
  }
}

export default inject("rootStore")(DigitalSeatIdFormatter);
